module.exports = __webpack_public_path__ + "static/shadow.f3d76a066d5ec4616ff28ccff655e9c8.png";